import { isShareSheetDismissed } from '../../lib/shareErrors';

export interface NewsSharePayload {
  title: string;
  description: string;
  url: string;
}

export interface NewsShareNavigator {
  share?: (data: { title: string; text: string; url: string }) => Promise<void>;
  clipboard?: { writeText: (text: string) => Promise<void> };
}

export type NewsShareResult = 'shared' | 'dismissed' | 'copied' | 'failed';

// WHY: делимся каноническим адресом из пропсов, а не location.href — в адресной строке бывают метки рекламы и ?page
export async function shareNews({ title, description, url }: NewsSharePayload, nav: NewsShareNavigator): Promise<NewsShareResult> {
  if (nav.share) {
    try {
      await nav.share({ title, text: description, url });
      return 'shared';
    } catch (err) {
      if (isShareSheetDismissed(err)) return 'dismissed';
    }
  }
  if (!nav.clipboard) return 'failed';
  try {
    await nav.clipboard.writeText(url);
    return 'copied';
  } catch {
    return 'failed';
  }
}
